/** O seletor de hub da tela de login, de 28/10/2026: HubTransGrãos ou HubVerticalFarm,
 *  por extenso e sempre visível, no alto do painel, acima do logo.
 *
 *  É um grupo de rádio: só a opção escolhida entra no Tab, e as setas trocam a
 *  escolha levando o foco junto. O seletor não autentica, só escolhe a porta. */
import { useRef, type CSSProperties, type KeyboardEvent } from 'react'
import { HUBS, type HubKey } from '@/core/hubs/hubs'
import { useI18n } from '@/core/i18n/useI18n'

interface Props {
  hub: HubKey
  onTrocar: (hub: HubKey) => void
  /** Durante o envio e no segundo fator, a porta já foi escolhida. */
  desabilitado?: boolean
}

const PASSO_DA_SETA: Record<string, number> = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }

export function SeletorDeHub({ hub, onTrocar, desabilitado = false }: Props) {
  const { t } = useI18n()
  const botoes = useRef<Array<HTMLButtonElement | null>>([])
  const indiceAtual = Math.max(0, HUBS.findIndex((h) => h.key === hub))

  const aoTeclar = (evento: KeyboardEvent<HTMLButtonElement>, indice: number) => {
    const passo = PASSO_DA_SETA[evento.key]
    if (!passo) return
    evento.preventDefault()
    const proximo = (indice + passo + HUBS.length) % HUBS.length
    onTrocar(HUBS[proximo].key)
    botoes.current[proximo]?.focus()
  }

  return (
    <div
      className="login-hubs"
      role="radiogroup"
      aria-label={t('auth.loginPage.hubSelectorAria')}
      aria-disabled={desabilitado || undefined}
      style={{ '--hub-indice': indiceAtual, '--hub-total': HUBS.length } as CSSProperties}
    >
      <span className="login-hubs-marcador" aria-hidden="true" />
      {HUBS.map(({ key, nome }, indice) => {
        const ativo = key === hub
        return (
          <button
            key={key}
            ref={(el) => {
              botoes.current[indice] = el
            }}
            type="button"
            role="radio"
            aria-checked={ativo}
            tabIndex={ativo ? 0 : -1}
            className="login-hubs-opcao"
            disabled={desabilitado}
            onClick={() => onTrocar(key)}
            onKeyDown={(evento) => aoTeclar(evento, indice)}
          >
            {nome}
          </button>
        )
      })}
    </div>
  )
}
